/* eslint-disable no-undef */
import Vue from 'vue'
import Router from 'vue-router'
import RouteView from '@/layouts/RouteView'
import MenuViewMoneyCat from '@/layouts/MenuView'
import Login from '@/pages/login/Login'
import Home from '@/pages/home'
import xlink from './icon'
let tmpRouterList = [
  {
    path: '/board',
    name: '核算组',
    icon: 'none',
    component: RouteView,
    children: [
      {
        path: '/zcm/board/hourly_order',
        name: '每刻报销订单',
        icon: xlink.hourlyOrder,
        component: () =>
          import(
            /* webpackChunkName: "HourlyReimbursementOrder" */ '@/pages/HourlyReimbursementOrder/HourlyReimbursementOrder'
          ),
      },
      {
        path: '/zcm/board/Generate_Kingdee_payment_payment',
        name: '实付生成金蝶付款单',
        component: () =>
          import(
            /* webpackChunkName: "GenerateKingdeePayment" */ '@/pages/GenerateKingdeePayment/GenerateKingdeePayment'
          ),
        icon: xlink.generatePayment,
      },
      {
        path: '/zcm/board/purchaseInventoryDataNew',
        name: '进销存数据',
        icon: xlink.purchaseInventoryData,
        component: () =>
          import(
            /* webpackChunkName: "PurchaseSaleDepositData" */ '@/pages/PurchaseSaleDepositData/PurchaseSaleDepositData'
          ),
      },
      {
        path: '/zcm/board/UnitsalesSummary',
        name: '单品销售汇总',
        icon: xlink.UnitsalesSummary,
        component: () =>
          import(
            /* webpackChunkName: "UnitsalesSummaryNew" */ '@/pages/UnitsalesSummaryNew/UnitsalesSummaryNew'
          ),
      },
    ],
  },
  {
    path: '/board1.0',
    name: '税务组',
    icon: 'none',
    component: RouteView,
    children: [
      {
        path: '/zcm/board/Invoice_input',
        name: '进项发票详情',
        icon: xlink.invoiceInput,
        component: () =>
          import(/* webpackChunkName: "Invoice_input" */ '@/pages/Invoice_input/Invoice_input'),
      },
      {
        path: '/zcm/board/TaxInvoiceInventoryDetails',
        name: '税票库存详情',
        icon: xlink.taxStamp,
        component: () =>
          import(
            /* webpackChunkName: "TaxInvoiceInventoryDetails" */ '@/pages/Tax_Stamp_Inventory/TaxInvoiceInventoryDetails'
          ),
      },
      {
        path: '/zcm/board/OrderDetails_index',
        name: '订单开票',
        component: () =>
          import(/* webpackChunkName: "OrderDetails" */ '@/pages/OrderDetails/index'),
        icon: xlink.orderDetailsIndex,
      },
      {
        path: '/zcm/board/DetailsOfSalesInvoices',
        name: '销项发票详情',
        icon: xlink.detailsTicket,
        component: () =>
          import(
            /* webpackChunkName: "DetailsOfSalesInvoices" */ '@/pages/DetailsOfSalesInvoices/DetailsOfSalesInvoices'
          ),
      },
      {
        path: '/zcm/board/details_of_special_ticket',
        name: '销项发票专票',
        icon: xlink.detailsSpecialTicket,
        component: () =>
          import(
            /* webpackChunkName: "DetailsOfSpecialTicket" */ '@/pages/DetailsOfSpecialTicket/DetailsOfSpecialTicket'
          ),
      },
      {
        path: '/zcm/board/Invoice_statistics',
        name: '发票汇总统计',
        icon: xlink.invoiceStatistics,
        component: () =>
          import(
            /* webpackChunkName: "Invoice_statistics" */ '@/pages/Invoice_statistics/Invoice_statistics'
          ),
      },
      {
        path: '/zcm/board/Bank_details',
        name: '银行流水明细',
        icon: xlink.BankDetails,
        component: () =>
          import(/* webpackChunkName: "BankDetails" */ '@/pages/BankDetails/BankDetails'),
      },
      {
        path: '/zcm/board/ReimbursementEveryMoment',
        name: '每刻报销',
        icon: xlink.hourlyOrder,
        component: () =>
          import(
            /* webpackChunkName: "ReimbursementEveryMoment" */ '@/pages/ReimbursementEveryMoment/ReimbursementEveryMoment'
          ),
      },
      {
        path: '/zcm/CostCarryForward/CostPriceCalculation',
        name: '成本核算',
        icon: xlink.CostPriceCalculation,
        component: () =>
          import(
            /* webpackChunkName: "CostPriceCalculation" */ '@/pages/CostCarryForward/CostPriceCalculation'
          ),
      },
      {
        path: '/zcm/CostCarryForward/CostPriceDetails',
        name: '成本价详情',
        icon: xlink.CostPriceDetails,
        component: () =>
          import(
            /* webpackChunkName: "CostPriceDetails" */ '@/pages/CostCarryForward/CostPriceDetails'
          ),
      },
      {
        path: '/zcm/CostCarryForward/CarryOverCost',
        name: '成本结转',
        icon: xlink.CarryOverCost,
        component: () =>
          import(/* webpackChunkName: "CarryOverCost" */ '@/pages/CostCarryForward/CarryOverCost'),
      },
      {
        path: '/zcm/CostCarryForward/CarryOverCostDetails',
        name: '成本结转明细',
        icon: xlink.CarryOverCostDetails,
        component: () =>
          import(
            /* webpackChunkName: "CarryOverCostDetails" */ '@/pages/CostCarryForward/CarryOverCostDetails'
          ),
      },
      {
        path: '/zcm/CostCarryForward/OpeningCostMaintenance',
        name: '期初成本维护',
        icon: xlink.OpeningCostMaintenance,
        component: () =>
          import(
            /* webpackChunkName: "OpeningCostMaintenance" */ '@/pages/CostCarryForward/OpeningCostMaintenance'
          ),
      },
      {
        path: '/zcm/CostCarryForward/UnitSalesSummary',
        name: '单品销售汇总',
        icon: xlink.UnitSalesSummary,
        component: () =>
          import(
            /* webpackChunkName: "UnitSalesSummary" */ '@/pages/CostCarryForward/UnitSalesSummary'
          ),
      },
    ],
  },
  {
    path: '/board2.0',
    name: '基础设置',
    icon: 'none',
    component: RouteView,
    children: [
      {
        path: '/board2.0_1',
        name: '核算账基础信息',
        icon: 'none',
        component: RouteView,
        children: [
          {
            path: '/zcm/board/employee_information',
            name: '员工信息',
            icon: xlink.employeeInformation,
            component: () =>
              import(/* webpackChunkName: "Employee" */ '@/pages/BaseInformation/Employee/index'),
          },
          {
            path: '/zcm/board/customer_information',
            name: '客户信息',
            icon: xlink.customerInformation,
            component: () =>
              import(/* webpackChunkName: "Customer" */ '@/pages/BaseInformation/Customer/index'),
          },
          {
            path: '/zcm/board/supplier_information',
            name: '供应商信息',
            icon: xlink.supplierInformation,
            component: () =>
              import(/* webpackChunkName: "Supplier" */ '@/pages/BaseInformation/Supplier/index'),
          },
          {
            path: '/zcm/board/material_information',
            name: '物料信息',
            icon: xlink.materialInformation,
            component: () =>
              import(/* webpackChunkName: "Material" */ '@/pages/BaseInformation/Material/index'),
          },
          {
            path: '/zcm/board/bank_account',
            name: '银行账号',
            icon: xlink.bankAccount,
            component: () =>
              import(
                /* webpackChunkName: "BankAccount" */ '@/pages/BaseInformation/BankAccount/index'
              ),
          },
        ],
      },
      {
        path: '/zcm/board/company_Information',
        name: '公司信息管理',
        icon: xlink.Companyinformation,
        component: () =>
          import(/* webpackChunkName: "CompanyInfo" */ '@/pages/BaseInformation/CompanyInfo'),
      },
      {
        path: '/zcm/board/Financial_information',
        name: '财务信息管理',
        icon: xlink.financialinformation,
        component: () =>
          import(/* webpackChunkName: "FinancialInfo" */ '@/pages/BaseInformation/FinancialInfo'),
      },
      {
        path: '/zcm/board/infodetails/:tid',
        name: '订单详情明细',
        component: () =>
          import(/* webpackChunkName: "infodetails" */ '@/pages/OrderDetails/infodetails'),
        icon: 'none',
        invisible: true,
      },
      {
        path: '/zcm/board/Order_invoice/:tid',
        name: '订单详情',
        component: () =>
          import(/* webpackChunkName: "Order_invoice" */ '@/pages/OrderDetails/Order_invoice'),
        icon: 'none',
        invisible: true,
      },
      {
        path: '/zcm/board/ticket_name_managemen',
        name: '货品名称和票面名称管理',
        icon: xlink.ticketManagemen,
        component: () =>
          import(/* webpackChunkName: "TicketNameInfo" */ '@/pages/BaseInformation/TicketNameInfo'),
      },
    ],
  },
  {
    path: '/board4.0',
    name: '开票中心',
    icon: 'none',
    component: RouteView,
    children: [
      {
        path: '/zcm/board/Billing_center',
        name: '开票中心',
        icon: xlink.BillingCenter,
        component: () =>
          import(/* webpackChunkName: "Billing_center" */ '@/pages/Billing_center/Billing_center'),
      },
      {
        path: '/zcm/board/Self_help_invoice',
        name: '自助开票',
        icon: 'none',
        invisible: true,
        meta: {
          keepAlive: true,
          isLeftGo: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Self_help_invoice" */ '@/pages/Billing_center/Self_help_invoice.vue'
          ),
      },
      {
        path: '/zcm/board/Start_booking',
        name: '开始开票(自助开票)',
        icon: 'none',
        invisible: true,
        component: () =>
          import(/* webpackChunkName: "Start_booking" */ '@/pages/OrderDetails/Start_booking.vue'),
      },
      {
        path: '/zcm/board/Plan_opening_order',
        name: '规划开票',
        icon: 'none',
        invisible: true,
        component: () =>
          import(
            /* webpackChunkName: "Plan_opening_order" */ '@/pages/Billing_center/Plan_opening_order.vue'
          ),
      },
      {
        path: '/zcm/board/Planning_invoicing_plan',
        name: '规划开票(开票计划)',
        icon: 'none',
        invisible: true,
        component: () =>
          import(
            /* webpackChunkName: "Planning_invoicing_plan" */ '@/pages/OrderDetails/Planning_invoicing_plan.vue'
          ),
      },
    ],
  },
  {
    path: '/board6.0',
    name: '费用中心',
    icon: 'none',
    component: RouteView,
    children: [
      {
        path: '/zcm/board/costCenter/AlipayDocuments',
        name: '账单费用汇总',
        icon: xlink.orderCount,
        component: () =>
          import(
            /* webpackChunkName: "AlipayDocuments" */ '@/pages/AlipayDocuments/AlipayDocuments'
          ),
      },
      {
        path: '/zcm/board/costCenter/OrderImportAndExport',
        name: '平台账单',
        icon: xlink.platformOrder,
        component: () =>
          import(
            /* webpackChunkName: "orderimportandexport" */ '@/pages/OrderImportAndExport/orderimportandexport'
          ),
      },
      {
        path: '/zcm/board/costCenter/BaseInformation',
        name: '基础资料',
        icon: xlink.CostPriceDetails,
        component: () =>
          import(
            /* webpackChunkName: "BaseInformation" */ '@/pages/CostCenter/BaseInformation/index.vue'
          ),
      },
      {
        path: '/zcm/board/costCenter/BillAnalysis',
        name: '平台账单解析规则',
        icon: xlink.CostPriceCalculation,
        component: () =>
          import(
            /* webpackChunkName: "BillAnalysis" */ '@/pages/CostCenter/BillAnalysis/index.vue'
          ),
      },
      {
        path: '/zcm/board/costCenter/UnidentifiedBill',
        name: '未识别账单处理',
        icon: xlink.BankDetails,
        component: () =>
          import(
            /* webpackChunkName: "UnidentifiedBill" */ '@/pages/CostCenter/UnidentifiedBill/index.vue'
          ),
      },
      {
        path: '/zcm/board/costCenter/FeeAccountRules',
        name: '费用账务规则',
        icon: xlink.orderDetailsIndex,
        component: () =>
          import(
            /* webpackChunkName: "FeeAccountRules" */ '@/pages/CostCenter/FeeAccountRules/index.vue'
          ),
      },
      // {
      //   path: '/zcm/board/costCenter/logisticsFeeCheck',
      //   name: '物流费核对',
      //   icon: xlink.orderDetailsIndex,
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "logisticsFeeCheck" */ '@/pages/LogisticsConfig/logisticsFeeCheck.vue'
      //     ),
      // },
      // {
      //   path: '/zcm/board/costCenter/logisticsBill',
      //   name: '物流账单',
      //   icon: xlink.orderDetailsIndex,
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "logisticsBill" */ '@/pages/LogisticsConfig/logisticsBill.vue'
      //     ),
      // },
    ],
  },
]
tmpRouterList
Vue.use(Router)
export default new Router({
  // mode: 'history',
  base: '/',
  routes: [
    {
      path: '/login',
      name: '登录页',
      component: Login,
      invisible: true,
    },
    {
      path: '/mainhome',
      name: '首页面',
      component: Home,
      invisible: true,
    },
    {
      path: '/zcm',
      name: '招财猫首页',
      component: MenuViewMoneyCat,
      icon: 'none',
      redirect: '/login',
      invisible: true,
      children: tmpRouterList,
    },
    {
      path: '*',
      redirect: '/login',
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/lazy.js